import * as DropdownMenu from '@wandb/weave/components/DropdownMenu';
import {Icon} from '@wandb/weave/components/Icon';
import React, {useState} from 'react';

import {DD_PRIVACY_ALLOW} from '../../../util/datadog/privacy';

type RunCopyIdentifiersSubmenuProps = {
  onCopyRunName: () => void;
  onCopyRunPath: () => void;
};

export const RunCopyIdentifiersSubmenu = ({
  onCopyRunName,
  onCopyRunPath,
}: RunCopyIdentifiersSubmenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <DropdownMenu.Sub open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenu.SubTrigger
        data-dd-action-name="Copy run identifiers"
        data-dd-privacy={DD_PRIVACY_ALLOW}>
        <Icon name="copy" />
        Copy...
        <Icon name="chevron-next" className="ml-auto text-wb-text-tertiary" />
      </DropdownMenu.SubTrigger>
      <DropdownMenu.Portal>
        {/* zIndex is needed so the dropdown is above the panel in reports */}
        <DropdownMenu.SubContent className="min-w-[130px]" style={{zIndex: 1}}>
          <DropdownMenu.Item
            data-dd-action-name="Copy run name"
            data-dd-privacy={DD_PRIVACY_ALLOW}
            onSelect={onCopyRunName}>
            Run name
          </DropdownMenu.Item>
          <DropdownMenu.Item
            data-dd-action-name="Copy run path"
            data-dd-privacy={DD_PRIVACY_ALLOW}
            onSelect={onCopyRunPath}>
            Run path
          </DropdownMenu.Item>
        </DropdownMenu.SubContent>
      </DropdownMenu.Portal>
    </DropdownMenu.Sub>
  );
};
